<nz-layout>
  <nz-sider
    nzTheme="light"
    nzCollapsible
    [nzCollapsedWidth]="size"
    [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null"
    >
    <a class="logo" routerLink="/cashier">
      @if (!isCollapsed) {
        <img
          class="logo-icon"
          src="/assets/images/logo.svg"
          />
      }
      @if (isCollapsed) {
        <img
          class="logo-icon"
          src="/assets/images/logo-mini.svg"
          />
      }
    </a>
    <ul nz-menu nzTheme="light" nzMode="inline" class="sider-menu">
      @for (nav of navigation; track nav) {
        @if (nav.children && nav.children.length) {
          <li
            nzMenuClassName="main-item"
            nz-submenu
            *ngxPermissionsOnly="nav.role || []"
            >
            <span title
              >@if (nav.icon) {
              <i nz-icon [nzType]="nav.icon"></i
                >
                }<span class="main-item">{{
                nav.translate | translate
              }}</span></span
              >
              <ul>
                @for (navChild of nav.children; track navChild) {
                  <li
                    *ngxPermissionsOnly="navChild.role || []"
                    [id]="navChild.id"
                    nz-menu-item
                    style="font-size: 12px"
                    [routerLink]="navChild.url"
                    routerLinkActive="ant-menu-item-selected"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >
                    {{ navChild.translate | translate }}
                  </li>
                }
              </ul>
            </li>
          } @else {
            <li
              nz-menu-item
              [id]="nav.id"
              [routerLink]="nav.url"
              *ngxPermissionsOnly="nav.role || []"
              >
              @if (nav.icon) {
                <i nz-icon [nzType]="nav.icon"></i>
              }
              <span>{{ nav.translate | translate }}</span>
            </li>
          }
        }
      </ul>
    </nz-sider>
    <nz-layout>
      <nz-header>
        <div nz-row nzGutter="20" nzAlign="middle">
          @if (size === 0 && isCollapsed) {
            <div nz-col nzFlex="initial">
              <a class="logo" routerLink="/cashier">
                <img class="logo-icon" src="/assets/images/logo-mini.svg" />
              </a>
            </div>
          }
          <div nz-col nzFlex="initial">
            <i
              class="trigger"
              nz-icon
              [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
              (click)="isCollapsed = !isCollapsed"
            ></i>
          </div>
          <div nz-col nzFlex="auto" style="height: 64px">
            <beautyapp-appointment-search
              *ngxPermissionsOnly="['Admin', 'Administrator', 'Manager']"
            ></beautyapp-appointment-search>
          </div>
          <div nz-col nzFlex="initial">
            <nz-select
              [(ngModel)]="lang"
              (ngModelChange)="langChange($event)"
              nzBorderless
              >
              <nz-option nzValue="ka" nzLabel="ქართ."></nz-option>
              <nz-option nzValue="en" nzLabel="Eng."></nz-option>
              <nz-option nzValue="ru" nzLabel="Рус."></nz-option>
            </nz-select>
          </div>
          <div nz-col nzFlex="initial">
            <div class="ant-btn-group">
              @if (selectedBranch$ | async; as branchSelected) {
                <button
                  *ngxPermissionsOnly="['Admin', 'Manager']"
                  nz-button
                  nz-dropdown
                  nzTrigger="click"
                  [nzDropdownMenu]="branchMenu"
                  nzPlacement="bottomRight"
                  >
                  {{ branchSelected?.name }}
                </button>
              }
              <button
                nz-button
                nz-dropdown
                [nzDropdownMenu]="profile"
                nzPlacement="bottomRight"
                >
                <i nz-icon nzType="user"></i>
              </button>
            </div>
            <nz-dropdown-menu #profile="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item routerLink="/profile/password-update">
                  {{ 'header.account.dropdown.changePassword' | translate }}
                </li>
                <li nz-menu-divider></li>
                <li nz-menu-item (click)="logout()">
                  <i nz-icon nzType="logout" nzTheme="outline"></i>
                  {{ 'header.account.dropdown.logOut' | translate }}
                </li>
              </ul>
            </nz-dropdown-menu>

            <nz-dropdown-menu #branchMenu="nzDropdownMenu">
              <ul nz-menu>
                @if (branches$ | async; as branches) {
                  @for (branch of branches; track branch) {
                    <li
                      nz-menu-item
                      (click)="setBranch(branch)"
                      >
                      {{ branch.name }}
                    </li>
                  }
                }
              </ul>
            </nz-dropdown-menu>
          </div>
        </div>
      </nz-header>
      <nz-content>
        <router-outlet></router-outlet>
      </nz-content>
      <nz-footer nzTheme="light">
        {{ 'footer.title' | translate }} WebApp.Ge
      </nz-footer>
    </nz-layout>
  </nz-layout>
